import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// import { Rate } from 'antd';
import "../../assets/css/doctor.scss";
import '../../assets/css/pharmacy.scss'

import { Button, Modal, Rate, Select, Slider } from "antd";

// img svg
import RightArrow from "../../assets/images/doctor/RightArrow.svg";
import EditIcon from "../../assets/images/pharmacy/EditIcon.svg";
import DeleteIcon from "../../assets/images/pharmacy/DeleteIcon.svg";

// img png
import PharmacyCardImg1 from '../../assets/images/pharmacy/PharmacyCardImg1.png'
import PharmacyCardImg2 from '../../assets/images/pharmacy/PharmacyCardImg2.png'
import PharmacyCardImg3 from '../../assets/images/pharmacy/PharmacyCardImg3.png'
import PharmacyCardImg4 from '../../assets/images/pharmacy/PharmacyCardImg4.png'
import PharmacyCardImg5 from '../../assets/images/pharmacy/PharmacyCardImg5.png'
import PharmacyCategoryImg1 from '../../assets/images/pharmacy/PharmacyCategoryImg1.png'
import PharmacyCategoryImg2 from '../../assets/images/pharmacy/PharmacyCategoryImg2.png'
import PharmacyCategoryImg3 from '../../assets/images/pharmacy/PharmacyCategoryImg3.png'
import PharmacyCategoryImg4 from '../../assets/images/pharmacy/PharmacyCategoryImg4.png'
import PharmacyCategoryImg5 from '../../assets/images/pharmacy/PharmacyCategoryImg5.png'
import PharmacyCategoryImg6 from '../../assets/images/pharmacy/PharmacyCategoryImg6.png'
import PharmacyCategoryImg7 from '../../assets/images/pharmacy/PharmacyCategoryImg7.png'
import PharmacyCounter from '../../components/common/PharmacyCounter';
import CustomSelect from '../../components/common/CustomSelect';

const PharmacyShop = () => {


  const dataImg = [
    {
      pic: PharmacyCategoryImg1,
      text1: 'Skin',
      text2: "Care"
    },
    {
      pic: PharmacyCategoryImg2,
      text1: 'Cough',
      text2: "& Cold"
    },
    {
      pic: PharmacyCategoryImg4,
      text1: 'Pain',
      text2: "Relief"
    },
    {
      pic: PharmacyCategoryImg3,
      text1: 'Heart',
      text2: "Health"
    },
    {
      pic: PharmacyCategoryImg5,
      text1: 'Diabetes',
      text2: "Care"
    },
    {
      pic: PharmacyCategoryImg6,
      text1: 'Cancer',
      text2: "Care"
    },
    {
      pic: PharmacyCategoryImg7,
      text1: 'Weight ',
      text2: "Management"
    }
  ]

  const data = [
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg1
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg2
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg3
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg3
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg4
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg5
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg1
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg2
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg3
    },
    {
      id: 1,
      productName: "Thermometer",
      price: "KWD 16.00",
      pic: PharmacyCardImg4
    },

  ]

  const [addProduct, setAddProduct] = useState(false);

  const [editProduct, setEditProduct] = useState(false);

  const [loading, setLoading] = useState(false);

  const [image, setImage] = useState(null);

  const [errorData, setErrorData] = useState(0);

  const [fileName, setFileName] = useState("");

  const handleDoctorImageClick = () => {
    // Create a file input element and trigger a click event
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    // input.accept = 'image/png,image/jpeg';  // its just show png and jpeg file rather then other
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) {
        setErrorData(0);
        return;
      }
      const fileType = file.type;
      if (fileType !== "image/png" && fileType !== "image/jpeg") {
        // alert('Please select a PNG or JPEG file');
        setErrorData(1);
        return;
      } else {
        setErrorData(0);
      }
      // Set the selected image as the state of the component
      setImage(null);
      setFileName(file.name);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    };
    input.click();
  };

  return (
    <>

      <div className="row px-2 pt-4">

        <div className="col-12  ">
          <p className="mb-0 dashboard-com-top-text">Pharmacy List</p>
        </div>

        <div className="col-12">
          <div className="row d-flex align-items-end">
            <div className="col-lg-6 col-12 mt-lg-0 mt-2">
              <p className="mb-0 doctor-header-top-text">
                <Link className="doc-link " to="">
                  DASHBOARD
                </Link>
                <img className="mx-lg-3 ml-2 pr-1 pb-1" src={RightArrow} alt="" />{" "}
                <Link className="doc-link " to="pharmacy">
                  <span>PHARMACY</span>{" "}
                </Link>
                <img className="mx-lg-3 ml-2 pr-1 pb-1" src={RightArrow} alt="" />{" "}
                <span style={{ color: "#4FA6D1" }}>PRODUCTS</span>{" "}
              </p>
            </div>

            <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex justify-content-end ">

              <button onClick={() => setAddProduct(true)} className="btn-add-new-doc"> Add Product </button>{" "}

            </div>
          </div>
        </div>

        <div className="col-12 mt-1">
          <p className='mb-0 py-4  pharmacy-view-product'>Most Viewed Products</p>
        </div>

        <div className="col-12 ">

          <div className="row px-2">

            {
              data.map(({ pic, productName, price }) => {
                return (
                  <>

                    <div class=" px-2 py-2 position-relative pharmacy-product-card-new" >

                      <div className=' pharmacy-product-card'>

                        <div className="pharmacy-product-card-img pt-2 px-2" >
                          <img src={pic} alt="" />
                        </div>

                        <div className='pb-2'>
                          <PharmacyCounter />
                        </div>

                        <hr className='my-0' />

                        <div className="div">
                          <span className='pharmacy-product-name pl-2'>{productName}</span>
                        </div>

                        <div className="div pharmacy-product-rate mb-2 d-flex justify-content-between align-items-center">
                          <span className='pharmacy-product-name pharmacy-product-price pl-2 pt-2 '>{price}</span>

                          <span className='pr-2 mr-1'>
                            <Rate allowHalf defaultValue={2.5} />
                          </span>
                        </div>
                      </div>

                      <div className='position-absolute pharmacy-product-edit'>

                        <img onClick={() => setEditProduct(true)} className='' src={EditIcon} />

                      </div>

                      <div className='position-absolute pharmacy-product-delete'>

                        <img className='' src={DeleteIcon} />

                      </div>

                    </div>

                  </>
                )
              })
            }



          </div>





        </div>

        <div className="col-12 mt-0">
          <p className='mb-0 py-4  pharmacy-view-product'>Categories</p>
        </div>


        <div className="col-12 mb-5">

          <div className="row px-2 mb-lg-5 pb-5">

            {
              dataImg.map(({ pic, text1, text2 }) => {
                return (
                  <>

                    <div class=" px-2 py-2 position-relative pharmacy-product-card-new" >

                      <div className=' pharmacy-product-card'>

                        <div className="pharmacy-product-card-img " >
                          <img src={pic} alt="" />
                        </div>

                      </div>

                      <div className='position-absolute pharmacy-product-cate'>

                        <p className='mb-0'>{text1}</p>
                        <p className='mb-0'>{text2} </p>

                      </div>

                    </div>

                  </>
                )
              })
            }



          </div>





        </div>


      </div>





      <Modal
        className="doctor-filter-modal"
        centered
        open={addProduct}
        // onOk={() => setModal2Open(false)}
        onCancel={() => setAddProduct(false)}
        width={925}
        footer={
          <div className="row px-3 mt-4 mb-2">


            <div className="col-12 d-flex justify-content-end mt-3">
              <button className="apply-filter submit-pharmacy-add-product">Add Product</button>
            </div>
          </div>
        }
      >








        <div className="row px-3 border-bottom">
          <div className="col-12 ">
            <p className=" pharmacy-modal-header">Add Product</p>
          </div>
        </div>


        <div className="row px-3">

          <div className="col-4">

            <p className='mb-0 pt-4 pb-3 pharmacy-add-text'>Upload your shop image here,
              Please click “Upload Image” Button.</p>

            {loading ? (
              <div className="loader-bar" />
            ) : (
              <div className="loader-bar-null" />
            )}
            {
              !loading ? <div className='info-message pt-1'>{fileName}</div> : <div className='pt-1'></div>
            }

            {errorData === 1 ? (
              <span className="error-message">
                Please select a valid image file (JPEG or PNG)
              </span>
            ) : (
              ""
            )}
            <button className='pharmacy-add-upload-img mt-3' onClick={handleDoctorImageClick} >Upload Image</button>








          </div>

          <div className="col-8">

            <div className="row px-3 mt-4">


              <div className="col-lg-12 mt-lg-0  mt-4  doc-setting-input">
                <p className=" doc-add-filter-text">
                  Item Title
                </p>

                <Select
                  defaultValue="Select"
                  style={{
                    width: "100%",
                  }}
                  onChange={() => { }}
                  options={[
                    {
                      label: "Cardiology0​​",
                      value: "Cardiology0"
                    },
                    {
                      label: "Neurology",
                      value: "Neurology"
                    },
                    {
                      label: "Cardiology​​",
                      value: "Cardiology"
                    },
                    {
                      label: "Neurology1",
                      value: "Neurology1"
                    },
                  ]}
                />
              </div>

              <div className="col-12">


                <div className="row mt-3">

                  <div className="col-lg-6 doc-setting-input">
                    <p className=" doc-add-filter-text">Price</p>

                    <div className='d-flex doc-setting-input-border-pharmacy justify-content-center align-items-center'>
                      <span className='border-right px-3' >$</span> <input className='doc-setting-input-inner' type="text" placeholder='Price' />
                    </div>
                  </div>

                  <div className="col-lg-6 mt-lg-0  mt-4  doc-setting-input">
                <p className=" doc-add-filter-text">
                  Item Title
                </p>

                <Select
                  defaultValue="Select"
                  style={{
                    width: "100%",
                  }}
                  onChange={() => { }}
                  options={[
                    {
                      label: "Cardiology0​​",
                      value: "Cardiology0"
                    },
                    {
                      label: "Neurology",
                      value: "Neurology"
                    },
                    {
                      label: "Cardiology​​",
                      value: "Cardiology"
                    },
                    {
                      label: "Neurology1",
                      value: "Neurology1"
                    },
                  ]}
                />
              </div>

                </div>

                <div className="row mt-3">

                <div className="col-lg-6 doc-setting-input">
                    <p className=" doc-add-filter-text">Sales Price</p>

                    <div className='d-flex doc-setting-input-border-pharmacy justify-content-center align-items-center'>
                      <span className='border-right px-3' >$</span> <input className='doc-setting-input-inner' type="text" placeholder='Price' />
                    </div>
                  </div>

                

                </div>

              </div>

            </div>

          </div>

        </div>

      </Modal>

      <Modal
        className="doctor-filter-modal"
        centered
        open={editProduct}
        // onOk={() => setModal2Open(false)}
        onCancel={() => setEditProduct(false)}
        width={925}
        footer={
          <div className="row px-3 mt-4 mb-2">


            <div className="col-12 d-flex justify-content-end mt-3">
              <button className="apply-filter submit-pharmacy-add-product">Add Product</button>
            </div>
          </div>
        }
      >








        <div className="row px-3 border-bottom">
          <div className="col-12 ">
            <p className=" pharmacy-modal-header">Edit Product</p>
          </div>
        </div>


        <div className="row px-3">

          <div className="col-4">

            <p className='mb-0 pt-4 pb-3 pharmacy-add-text'>Upload your shop image here,
              Please click “Upload Image” Button.</p>

            {loading ? (
              <div className="loader-bar" />
            ) : (
              <div className="loader-bar-null" />
            )}
            {
              !loading ? <div className='info-message pt-1'>{fileName}</div> : <div className='pt-1'></div>
            }

            {errorData === 1 ? (
              <span className="error-message">
                Please select a valid image file (JPEG or PNG)
              </span>
            ) : (
              ""
            )}
            <button className='pharmacy-add-upload-img mt-3' onClick={handleDoctorImageClick} >Upload Image</button>








          </div>

          <div className="col-8">

            <div className="row px-3 mt-4">


              <div className="col-lg-12 mt-lg-0  mt-4  doc-setting-input">
                <p className=" doc-add-filter-text">
                  Item Title
                </p>

                <Select
                  defaultValue="Select"
                  style={{
                    width: "100%",
                  }}
                  onChange={() => { }}
                  options={[
                    {
                      label: "Cardiology0​​",
                      value: "Cardiology0"
                    },
                    {
                      label: "Neurology",
                      value: "Neurology"
                    },
                    {
                      label: "Cardiology​​",
                      value: "Cardiology"
                    },
                    {
                      label: "Neurology1",
                      value: "Neurology1"
                    },
                  ]}
                />
              </div>

              <div className="col-12">


                <div className="row mt-3">

                  <div className="col-lg-6 doc-setting-input">
                    <p className=" doc-add-filter-text">Price</p>

                    <div className='d-flex doc-setting-input-border-pharmacy justify-content-center align-items-center'>
                      <span className='border-right px-3' >$</span> <input className='doc-setting-input-inner' type="text" placeholder='Price' />
                    </div>
                  </div>

                  <div className="col-lg-6 mt-lg-0  mt-4  doc-setting-input">
                <p className=" doc-add-filter-text">
                  Item Title
                </p>

                <Select
                  defaultValue="Select"
                  style={{
                    width: "100%",
                  }}
                  onChange={() => { }}
                  options={[
                    {
                      label: "Cardiology0​​",
                      value: "Cardiology0"
                    },
                    {
                      label: "Neurology",
                      value: "Neurology"
                    },
                    {
                      label: "Cardiology​​",
                      value: "Cardiology"
                    },
                    {
                      label: "Neurology1",
                      value: "Neurology1"
                    },
                  ]}
                />
              </div>

                </div>

                <div className="row mt-3">

                <div className="col-lg-6 doc-setting-input">
                    <p className=" doc-add-filter-text">Sales Price</p>

                    <div className='d-flex doc-setting-input-border-pharmacy justify-content-center align-items-center'>
                      <span className='border-right px-3' >$</span> <input className='doc-setting-input-inner' type="text" placeholder='Price' />
                    </div>
                  </div>

                

                </div>

              </div>

            </div>

          </div>

        </div>

      </Modal>


    </>
  )
}

export default PharmacyShop